import { render, staticRenderFns } from "./03-Capture.vue?vue&type=template&id=755e149d&scoped=true&"
import script from "./03-Capture.vue?vue&type=script&lang=js&"
export * from "./03-Capture.vue?vue&type=script&lang=js&"
import style0 from "./03-Capture.vue?vue&type=style&index=0&id=755e149d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "755e149d",
  null
  
)

export default component.exports